<template>
    <div id="tablet-version-popup" class="full-size" v-show="data.isShow">
    <div class="content">
        <p v-if="!isTouchDevice()">教圖互動書架提供其他版本，您可</p>
        <p v-else>我們建議使用 App 版或個人電腦，<br>以獲得最佳的使用體驗。</p>
        <a href="#"
           class="hover-effect"
           @click.prevent="useWebVersion"
           id="btn-continue"
        >
            <img src="~images/btn-continue-web.png">
        </a>
        <p>{{ i18n.t("label_bestview")}}</p>
        <div class="splitter">
            <span class="hr"></span><span class="or"> 或 </span><span class="hr"></span>
        </div>
        　<p>下載其他版本</p>
         <version-download-control :paramSsoToken="props.paramSsoToken"></version-download-control>
    </div>
    <div class="mask full-size"></div>
    </div>
</template>

<script>
    import {ref, reactive, onMounted, onUnmounted, onUpdated, watchEffect, watch, computed,nextTick, inject}  from "vue";
    import {authenticate, handleSSO} from "@/modules/api/auth";
    import {changeLang} from "@/modules/i18n/i18n";
    import SimpleList from "@/views/lib/listing/SimpleList";
    import VersionDownloadControl from "@/views/versionSelect/VersionDownloadControl";
    import Links from "@/views/template/Links";
    import router from "@/router"
    import config from "@/config/config.json";
    import {isTouchDevice, isIOS} from "@/modules/utils/deviceUtils";

    export default {
        props: {
            paramSsoToken:String,
            param_ebookcode:String,
            param_page:Number
        },
        components:{
            VersionDownloadControl
        },
        setup(props, context) {

            const data = reactive({
                isShow:true
            })

            const i18n = inject('i18n');

            const useWebVersion = ()=>{

               if (isTouchDevice() && !props.paramSsoToken) {
                    data.isShow = false;
               } else {
                   if (props.param_ebookcode) {
                       router.push({path: "reader", query: {ebookcode: props.param_ebookcode}})
                       if (props.param_page) {
                           router.push({
                               path: "reader",
                               query: {ebookcode: props.param_ebookcode, page: props.param_page}
                           })
                       }
                   } else {
                       router.push("home");
                   }
               }
            }

            return {
                data,
                props,
                i18n,
                useWebVersion,
                isTouchDevice
            }
        }
    }

</script>

<style scoped lang="scss">


    #tablet-version-popup {
        left:0;
        top:0;
        position:fixed;
        justify-content: center;
        align-items: center;
        display:flex;
        z-index:1;
    }

    .content {
        width:480px;
        height:320px;
        background:#fff;
        padding:50px;
        border-radius:5px;
        margin:0 auto;
        z-index:1;
        text-align:center;
        color:$text-color-primary;
    }

    .mask {
        position:fixed;
        background:rgba(0,0,0,0.4);
    }

    #btn-continue {
        width:184px;
        height:58px;
        display:block;
        margin:0 auto;

        img {
            width:100%;
        }
    }

    .splitter {
        display: flex;
        align-items: center;
        margin:0 0 -20px 0;

        .or {
            margin: 0 10px;
            color: #c3c3c3;
        }

        .hr {
            flex: 1;
            height: 1px;
            background: #c3c3c3;
            width: 100%;
        }
    }
</style>